import { z } from "zod";


export const TokenSchema = z.object({
  id: z.number(),
  token: z.string()
});

export const ValidateResponseSchema = z.object({
  is_register: z.boolean(),
  is_phone_number: z.boolean()
});

export const RegisterResponseSchema = z.object({
  message: z.string()
});

